import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import MoneyTransferForm from './forms/MoneyTransferForm';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import MoneyTransferList from "./lists/MoneyTransferList";
import {postData} from "../../utils/request";
import Modal from "../layout/Modal";
import Button from "../form/Button";
import connect from "react-redux/es/connect/connect";
import {showModal} from "../../actions";
import isEqual from "lodash-es/isEqual";
import {loadComponent} from "../../utils/components";
import Icon from "../form/Icon";
import {CurrencyFormatter} from "../../utils/formatters";
import Portal from "../layout/Portal";
import DateTimeInput from "../form/DateTimeInput";

class RemainingButton extends React.Component {

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.values[prevProps.componentConfig.idfield] + "" !== "" + this.props.values[this.props.componentConfig.idfield]) {
            this.load();
        }
    }

    load = () => {
        this.setState({amount: 0}, () => {
            if (!(this.props.values[this.props.componentConfig.idfield] && (this.props.values.partner ||{}).partner_id)) return;
            this.loadBalance && this.loadBalance.abort();

            this.loadBalance = loadComponent("componentlist", {
                withheader: 1,
                parentcomponent: this.props.componentConfig.componentname,
                parentid: this.props.values[this.props.componentConfig.idfield],
                listfield: "TransactionPayments",
                itemsperpage: 1,
                aggregations: {
                    fields: {
                        "total": {
                            field: "total", type: "SUM"
                        },
                        "amount": {
                            field: "amount", type: "SUM"
                        },
                        "transaction.balance": {
                            field: "transaction.balance", type: "SUM"
                        },
                        "transaction.relativeamount": {
                            field: "transaction.relativeamount", type: "SUM"
                        },
                        "full": {
                            expression: "{{transaction.relativeamount}} - {{total}}"
                        },
                    }
                }
            });
            this.loadBalance.then((response) => {
                const amount = parseFloat(((response.aggregations || [])[0] || {}).full || 0);
                this.setState({amount});
            });
        });
    }

    render() {
        return (
            (this.state ||{}).amount && (this.props.values.state || "0") + "" !== "0" ? <Button
                disabled={this.props.isLoading || this.props.dirty}
                color="primary"
                className="pull-right"
                onClick={(e) => this.props.remaining(this.state.amount, e)}
            >
                <span className="currency"><Icon lib="fas" name="money-bill-wave" />{" " + CurrencyFormatter(this.state.amount).props.children}</span>
            </Button> : null
        );
    }
}

class MoneyTransferEditor extends React.Component {

    state = {
        message: null,
        messageType: null
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        if (!this.props.values[this.props.componentConfig.idfield]) {
            let data = {};
            if (this.props.values.moneyrepository === undefined) {
                data.moneyrepository = this.props.till.moneyrepositories.find((moneyrepository) => moneyrepository.component_type === "BankAccount") || null;
            }
            if (Object.keys(data).length) {
                await this.props.setFormValues({...this.props.values, ...data});
            }
        }
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
        this.form.picklist && this.form.picklist.refresh();
    }

    getFieldProps = (name) => {
        const props = this.props.getFieldProps(name);
        if (name !== "comment" && name !== "comment.text") {
            props.disabled = props.disabled || !(this.props.values.state + "" === "0" || this.props.values.compensated != 0);
        }
        return props;
    }

    proceed = async (e) => {
        e && e.preventDefault();
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.proceed',
                data: values
            });
            this.list && this.list.refreshBackground();
            this.form && this.form.refreshBackground();
            this.form.picklist && this.form.picklist.source.refresh();
            this.form.picklist && this.form.picklist.target.refresh();
            this.props.showModal({
                size: "small",
                theme: "success",
                header: "Sikeres művelet",
                text: "Sikeres lezárás!",
                timeout: 1500
            });
            return response;
        });
    }

    remaining = (amount = null, e) => {
        e && e.preventDefault();
        if (!this.state.opened) {
            this.setState({opened: true, amount});
            return;
        }
        const values = this.props.values;
        this.setState({isLoading: true}, async () => {
            try {
                await this.props.processAction(async () => {
                    const response = await postData({
                        action: this.props.componentConfig.componentname + '.remaining',
                        data: values,
                        transferdate: this.state.transferdate || null,
                    });
                    this.list && this.list.refreshBackground();
                    this.form && this.form.refreshBackground();
                    this.remainingButton && this.remainingButton.load();
                    this.form.refreshLists && this.form.refreshLists();
                    this.props.showModal({
                        size: "small",
                        theme: "success",
                        header: "Sikeres művelet",
                        text: "Sikeres lezárás!",
                        timeout: 1500
                    });
                    return response;
                });
                this.setState({opened: false, amount: 0, isLoading: false});
            } catch (e) {
                this.setState({opened: false, amount: 0, isLoading: false});
                throw e;
            }
        });
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <Modal
                    state={this.state.message !== null ? "on" : "off"}
                    theme={this.state.messageType}
                    size={"large"}
                    header="Mentés"
                    buttons={[
                        {
                            text: 'Ok',
                            onClose: true,
                            onClick: async () => {
                                this.setState({message: null, messageType: null});
                            }
                        }
                    ]}
                >
                    {this.state.message}
                </Modal>
                <List
                    {...this.props}
                    theme="default"
                    header="Tranzakciók"
                    footer={[
                        <Button
                            key="0"
                            color="default"
                            disabled={this.props.isLoading}
                            onClick={this.pristineForm}>
                            Új
                        </Button>
                    ]}
                >
                    <MoneyTransferList
                        moneyrepositoryType="BankAccount"
                        ref={(el) => this.list = el}
                        {...this.props}
                        loadForm={this.loadForm}
                    />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Tranzakció"
                    footer={<Fragment>
                        {
                            this.props.values[this.props.componentConfig.idfield] &&
                            <Button
                                disabled={this.props.isLoading || this.props.dirty || !(this.props.values.state + "" === "0" || this.props.values.compensated != 0)}
                                color="primary"
                                className="pull-right"
                                onClick={this.proceed}
                            >
                                Lezárás
                            </Button>
                        }
                        <Button
                            disabled={this.props.values[this.props.componentConfig.idfield] ? this.props.isLoading || this.props.values.state + "" !== "0" : true}
                            color="danger"
                            className="pull-left"
                            onClick={this.props.deleteForm}
                        >
                            Törlés
                        </Button>
                        <Button
                            disabled={(this.props.values[this.props.componentConfig.idfield] && !isEqual(this.props.values.comment, this.props.initialValues.comment)) ? false : (this.props.values.direction === undefined || this.props.isLoading || !this.props.dirty || !(this.props.values.state + "" === "0" || this.props.values.compensated > 2 || this.props.values.compensated === null || this.props.values.compensated === undefined))}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                        {this.state.opened && <Portal>
                            <Modal
                                state="on"
                                header={this.state.amount > 0 ? "Bejövő pénz" : "Kifizetés"}
                                size="small"
                                buttons={[
                                    {
                                        text: "Mégse",
                                        props: {color: "default", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                        onClose: true,
                                        onClick: async () => {
                                            try {
                                                this.setState({opened: false});
                                            } catch (e) {

                                            }
                                        }
                                    },
                                    {
                                        text: "Rögzítés",
                                        props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                        onClick: (e) => {
                                            this.remaining(null, e);
                                        }
                                    }
                                ]}
                            >
                                <div className="row form-row">
                                    <div className="col-md-12">
                                        <DateTimeInput
                                            name="transferdate"
                                            label="Kompenzáció dátuma"
                                            value={this.state.transferdate}
                                            showTime={false}
                                            saveChanges={(field, value) => this.setState({[field]: value})}
                                        />
                                    </div>
                                </div>
                            </Modal>
                        </Portal>}
                        {/*<RemainingButton
                            ref={(remainingButton) => this.remainingButton = remainingButton}
                            {...this.props}
                            remaining={this.remaining}
                        />*/}
                    </Fragment>}
                >
                    <MoneyTransferForm
                        moneyrepositoryType="BankAccount"
                        ref={(form) => this.form = form}
                        {...this.props}
                        reloadAmount={() => {
                            this.remainingButton && this.remainingButton.load();
                        }}
                        getFieldProps={this.getFieldProps}
                    />
                </Editor>
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
},{showModal})(createEditor({
    componentName: "MoneyTransfer",
    editor: "TransactionPayment",
    WrappedComponent: MoneyTransferEditor,
    props: {
        view: "admin",
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
}));
